'use strict';

module.exports.AppContainer = require('./AppContainer');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/lib/index.prod.js
 ** module id = ./node_modules/react-hot-loader/lib/index.prod.js
 ** module chunks = 0
 **/